import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useApplicationContext } from '~/shared/context/use-application-context';

import type { UrlTileDefinition } from '../types';
import type { ResolvedTileAvailability } from './resolve-available-tiles';
import { resolveTileAvailability } from './resolve-available-tiles';
import type { TileRoutePolicy } from './types';

export const useAvailableTileDefinitions = ({
    definitions,
    policies,
}: {
    readonly definitions: readonly UrlTileDefinition[];
    readonly policies: readonly TileRoutePolicy[];
}): ResolvedTileAvailability => {
    const { pathname } = useLocation();
    const { applicationState } = useApplicationContext();
    const { featureFlagService } = applicationState;

    return useMemo(
        () => resolveTileAvailability({ pathname }, policies, { definitions, featureFlagService }),
        [definitions, featureFlagService, pathname, policies],
    );
};
